import { useInfiniteQuery } from 'react-query';
import { Call, Paginated } from 'src/core/types';
import { getParameterByName } from 'src/core/yup';

import axios from './axios';

const fetchCallLog = ({ pageParam = 1 }) =>
  axios
    .get<Paginated<Call>>(`/posht/yashar/calls/?page=${pageParam}`)
    .then((res) => res.data);

export function useCallLog() {
  return useInfiniteQuery<Paginated<Call>>(['call-logs'], fetchCallLog, {
    getNextPageParam: (lastPage) => getParameterByName('page', lastPage.next),
  });
}
